export enum Loading {
  GLOBAL = 'global',
  LOCAL = 'local'
}
